<div class="loader-overlay" *ngIf="isLoading">
  <div class="loading-small-screen-scroll trst w-auto">
    <img src="assets/images/landing-page/loading-more.svg" alt="Loader"/>
    <div class="col-12 text-center"> {{customMessage}} <div class="loader-dots"></div></div>
    <div class="col-12 text-center">
      Please wait <div class="loader-dots"></div>
    </div>
  </div>
</div>
